export enum Operation$Status {
  IN_PROGRESS = 0,
  DONE = 1,
  FAILED = 2,
}

export interface OperationEntity<T = unknown> {
  operationId: Nullable<string>;
  entityId: Nullable<string>;
  state: Operation$Status;
  errorReason: string[];

  data: T;
}

export class OperationError<T = unknown> extends Error implements OperationEntity<T> {
  operationId: Nullable<string>;
  entityId: Nullable<string>;
  state: Operation$Status;
  errorReason: string[];
  data: T;

  constructor(op: OperationEntity<T>) {
    super(op.errorReason.join('\n') || 'Operation failed');
    this.operationId = op.operationId;
    this.entityId = op.entityId;
    this.state = op.state;
    this.errorReason = op.errorReason;
    this.data = op.data;
  }
}

export function isOperation(data: unknown): data is OperationEntity {
  return (
    Object.prototype.hasOwnProperty.call(data, 'operationId') &&
    Object.prototype.hasOwnProperty.call(data, 'entityId') &&
    Object.prototype.hasOwnProperty.call(data, 'state')
  );
}
